import moment, { Moment } from 'moment';

import ApiPlan from 'types/api/Plan';
import { Option } from 'types/options';

import Model from 'models/Model';
import PlanFeatures from 'models/PlanFeatures';

import { getFormattedDate } from 'utils/date';
import { changeFromCent, displayPrice } from 'utils/math';

export default class Plan implements Model {
    id: string;
    createdAt: Moment;
    createdAtDisplay: string;
    enabled: boolean;
    name: string;
    slug: string;
    description: string;
    priceMonth: number;
    priceMonthDisplay: string;
    priceYear: number;
    priceYearDisplay: string;
    planFeatures: PlanFeatures[];

    constructor(data: ApiPlan) {
        this.id = data.id;
        this.createdAt = data.createdAt && moment.utc(data.createdAt).local();
        this.createdAtDisplay = this.createdAt && getFormattedDate(this.createdAt);
        this.enabled = data.enabled;
        this.name = data.name;
        this.slug = data.slug;
        this.description = data.description;
        this.priceMonth = data.priceMonth;
        this.priceMonthDisplay = displayPrice(changeFromCent(this.priceMonth));
        this.priceYear = data.priceYear;
        this.priceYearDisplay = displayPrice(changeFromCent(this.priceYear));
        this.planFeatures = data.planFeatures;
    }

    getOption = (): Option<Plan> => {
        return {
            value: this,
            label: this.name,
        };
    };
}
